(function () {
  function initSection(root) {
    const container = root.querySelector(".our_kids_product-wrap.swiper");
    if (!container) return;

    const nextEl = root.querySelector(".recipe-product-slider-arrow-right");
    const prevEl = root.querySelector(".recipe-product-slider-arrow-left");

    let swiper = null;

    // Slider ON for <= 1024
    const mq = window.matchMedia("(max-width: 1024px)");

    const initSwiper = () => {
      if (swiper || typeof Swiper === "undefined") return;

      swiper = new Swiper(container, {
        slidesPerView: 2,      // mobile looks like your Image [1]
        spaceBetween: 10,
        initialSlide: 1,
        centeredSlides: false,
        loop: true,
        navigation: {
          nextEl,
          prevEl,
        },
        breakpoints: {
        },
      });
    };

    const destroySwiper = () => {
      if (!swiper) return;

      swiper.destroy(true, true);
      swiper = null;

      // cleanup inline styles from Swiper
      const wrapper = container.querySelector(".swiper-wrapper");
      if (wrapper) wrapper.removeAttribute("style");

      container.querySelectorAll(".swiper-slide").forEach((slide) => {
        slide.removeAttribute("style");
      });

      container.classList.remove("swiper-initialized");
    };

    const handle = (e) => {
      if (e.matches) initSwiper();   // <= 1024
      else destroySwiper();          // >= 1025 (grid)
    };

    handle(mq);
    if (mq.addEventListener) mq.addEventListener("change", handle);
    else mq.addListener(handle);
  }

  function initAll() {
    document.querySelectorAll(".our_kids_product_wrapper").forEach(initSection);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
})();
